import { redirect, useActionData, useParams, useRevalidator, useRouteLoaderData, useSubmit } from "react-router-dom";
import ModalUrlWindow from "../../components/modalUrl";
import api from "../../hooks/useApi";
import jsonToFormData from "../../hooks/jsonToFormData";
import { Autoform } from "../../components/forms/autoform";
import { useForm } from "react-hook-form";
import { Alert } from "@mui/material";
import PageTitle from "../../components/PageTitle";

const SAFE_FIELDS = new Set(['email', 'name', 'second_name', 'last_name', 'phone', 'birth_date', 'city_of_residence']);


export default function ProfileEditField() {
    const { id, field_name } = useParams();
    const submit = useSubmit();
    const adminData = useRouteLoaderData('admin_profile_details');
    const profileData = useRouteLoaderData('profile_details');
    const parentData = adminData || profileData;
    const { form, user } = parentData || {};
    const defaultValues = {};
    defaultValues[field_name] = user?.[field_name];
    const formHook = useForm({ defaultValues: { ...defaultValues } });
    const actionData = useActionData()
    const revalidator = useRevalidator();

    if (!SAFE_FIELDS.has(field_name) || !form || !user) {
        return <ModalUrlWindow url='/adminH123H/details' title={{ text: 'Редагування недоступне' }} width='sm'><Alert severity='error'>Це поле не можна редагувати.</Alert></ModalUrlWindow>;
    }

    const handleSubmitForm = (data) => {
        const confirm = window.confirm("Ви впевнені що хочете застосувати зміни?");
        if (!confirm) return;
        const confirm2 = window.confirm("Ви ТОЧНО впевнені?");
        if (!confirm2) return;

        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post',
            encType: 'multipart/form-data',
            action: 'submit'
        })
    }
    const fields = {}
    fields[field_name] = form?.[field_name]
    //console.log(fields);

    return (
        <ModalUrlWindow
            url='/adminH123H/details'
            title={{ text: "Змінити інформацію користувача" }}
            width='sm'
        >
            <PageTitle title={`Редагування профілю: ${field_name || "поле"}`} />
            <Autoform
                formHook={formHook}
                fields={fields}
                onSubmit={handleSubmitForm}
                formName='HotelOwner'
                revalidator={revalidator}
            />
            {actionData?.response && (
                <Alert severity='error'>
                    {JSON.stringify(actionData.response)}
                </Alert>
            )}
        </ModalUrlWindow>
    )
}
